var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import BackBtn from '../../BackBtn';
import { PickButton } from '../MoveControls';
import { matchLabel, matchSubLabel } from '../moveHelpers';
var SourcePickStep = function (_a) {
    var sourceMatches = _a.sourceMatches, onPick = _a.onPick, onBack = _a.onBack;
    var t = useTranslation().t;
    return (_jsxs("div", { children: [_jsx("h2", __assign({ className: 'mb-2 text-sm font-bold text-gray-700' }, { children: t('Multiple matches, select one') }), void 0), _jsx("div", __assign({ className: 'space-y-2' }, { children: sourceMatches.map(function (m, i) { return (_jsx(PickButton, { label: matchLabel(m), sub: matchSubLabel(m, t), onClick: function () { return onPick(m); } }, "m-" + i)); }) }), void 0), _jsx("div", __assign({ className: 'mt-4' }, { children: _jsx(BackBtn, { onClick: onBack, type: 'button' }, void 0) }), void 0)] }, void 0));
};
export default SourcePickStep;
